
import React, { useState, useEffect } from 'react';

const Teacher = (props) => {
    return (
        <React.Fragment>
            <div className="col-md-12">
                <div className="text-center">
                    
                    <div className="user-image mb-3">
                        <img src={props.teacher.avatar.url} className="img-thumbnail" width={90}/>
                    </div>
                    
                    <div className="user-content">
                        <h5 className='mb-2 text-primary'>{props.teacher.name}</h5>
                        <span className='mb-2 text-primary'>Instructor especializado y calificado</span>
                        <p className='mt-2 text-dark'>{props.teacher.bio}</p>
                    </div>
                    
                    <div className="ratings">
                        <span style={{ color: "orange" }} className="fa fa-star"></span>
                        <span style={{ color: "orange" }} className="fa fa-star"></span>
                        <span style={{ color: "orange" }} className="fa fa-star"></span>
                        <span style={{ color: "orange" }} className="fa fa-star"></span>
                        <span style={{ color: "orange" }} className="fa fa-star"></span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}


export default Teacher;